export const REACT_APP = {
  SERVER_IP: process.env.REACT_APP_BASE_URL,
  TWITTER_ID: '1002103497725173760',
};
